import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ClerkAuthProvider from "./components/auth/ClerkAuthProvider";
import Home from "./pages/Home";
import Songs from "./pages/Songs";
import SongDetail from "./pages/SongDetail";
import Karaoke from "./pages/Karaoke";
import Dodo from "./pages/Dodo";
import BiniSky from "./pages/BiniSky";
import Parents from "./pages/Parents";
import Admin from "./pages/Admin";
import { SignInPage, SignUpPage } from "./pages/Auth";
import Coloring from "./pages/Coloring";
import Legal from "./pages/Legal";
import Unsubscribe from "./pages/Unsubscribe";
import { PaymentSuccess, PaymentCancel, DownloadPage, LostLinkPage } from "./pages/Payment";
import ComingSoon from "./pages/ComingSoon";

// Clerk only loads on admin pages: the children's site stays free of any sign-in script
const AuthArea = () => <ClerkAuthProvider><Outlet /></ClerkAuthProvider>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/comptines" element={<Songs />} />
        <Route path="/comptines/:slug" element={<SongDetail />} />
        <Route path="/comptines/:slug/karaoke" element={<Karaoke />} />
        <Route path="/mode-dodo" element={<Dodo />} />
        <Route path="/ciel-de-bini" element={<BiniSky />} />
        <Route path="/coloriages" element={<Coloring />} />
        <Route path="/espace-parents" element={<Parents />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/telechargement/:token" element={<DownloadPage />} />
        <Route path="/mon-lien" element={<LostLinkPage />} />
        <Route path="/mentions-legales" element={<Legal slug="mentions-legales" />} />
        <Route path="/confidentialite" element={<Legal slug="confidentialite" />} />
        <Route path="/cgv" element={<Legal slug="cgv" />} />
        <Route path="/newsletter/desinscription" element={<Unsubscribe />} />
        <Route element={<AuthArea />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
        </Route>
        <Route path="*" element={<ComingSoon page="notFound" />} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
